export default __webpack_public_path__ + "images/AM.c6ce996.png";